export default __webpack_public_path__ + "static/media/mansadevi.7e842829.jpg";